<template>
  <f-card class="h-100 bg-light">
    <f-card-body class="h-100">
      <h4>{{ review.mark }} / 5.00 {{ ratingText }}</h4>
      <div>
        <i v-for="star in fullStars" class="fas fa-star star-color"></i>
        <i v-for="star in emptyStars" class="fas fa-star"></i>
        am {{ date }}
      </div>
      <b>{{fullProfile}}</b>
      <p><small>{{ review.vehicle }}</small></p>
      <p class="mt-3">
        {{ comment }}
      </p>

      <i :id="review.UID" class="fal fa-check-circle text-success verified-icon"></i>
      <f-tooltip :target="review.UID" custom-class="uvp-tooltip">Verifizierte Buchung</f-tooltip>
    </f-card-body>
  </f-card>
</template>

<script>
    export default {
      name: "CustomerReview",
      components: {},
        props: {
            review: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                maxCommentLength: 200,
            };
        },
        methods: {},
        computed: {
          fullProfile() {
            if(this.hasProfile)
              return `${this.profile.firstname} ${this.profile.lastname} aus ${this.profile.city}`
            else
              return "Anonymer Abo-Kunde"
          },
            date(){
                let date = new Date(this.review.confirmationDate);

                let day = date.getDate();
                if(date < 10){
                  day = "0" + day
                }
                let monthIndex = date.getMonth() + 1;
                if(monthIndex < 10){
                    monthIndex = "0" + monthIndex;
                }
                let year = date.getFullYear();

                return day + "." + monthIndex + "." + year;
            },
            comment(){
                let comment = this.review.comment;
                if(comment.length > this.maxCommentLength){
                    return comment.substring(0, this.maxCommentLength) + " [...]";
                }
                return comment;
            },
            profile() {
                if (this.hasProfile) {
                    return this.review.reviewer.profile;
                } else {
                    return {};
                }
            },
            hasProfile() {
                return typeof this.review.reviewer !== "undefined";
            },
            rating() {
                return Math.round(parseFloat(this.review.mark));
            },
            ratingText() {
                let rating = "nicht verfügbar";
                if (typeof this.review.markDescriptionGUILanguage !== "undefined") {
                    rating = this.review.markDescriptionGUILanguage;
                } else {
                    let rating = this.review.markDescription;
                    switch (this.review.markDescription) {
                        case "EXCELLENT":
                            rating = "sehr gut";
                            break;
                        default:
                            rating = this.review.markDescription;
                            break;
                    }
                }
                return rating;
            },
            fullStars() {
                return this.rating;
            },
            emptyStars() {
                return 5 - this.rating;
            },
            vehicle(){
                if(typeof this.review.vehicle === 'undefined' || this.review.vehicle === null){
                    return "";
                }
                return this.review.vehicle;
            }
        }
    }
</script>

<style type="scss" scoped>
    .review-card {
        height: 100%;
    }
    .star-color {
      color: #FFBF00;
    }
    .verified-icon {
      position: absolute;
      top: 10px;
      right: 10px;
    }
</style>
